import React from "react";

import BatchDetail from "../../../common/BatchDetail";
import { planPurchaseColumns } from "../../../../constants/lineListColumns";
import { CLIENTS } from "../../../../constants/value";
import { __getPlanPurchase } from "../../../../api/sim";
import { PLAN_PURCHASE_OPERATIONS } from "../../../../utils/planPurchase";

const COPY_KEYS = [
  "id",
  "batch_id",
  "iccid",
  "plan_id",
  "purchase_id",
  "status",
  "last_updated",
];

const PlanPurchaseBatch = ({ operation }) => {
  const config = PLAN_PURCHASE_OPERATIONS[operation];

  return (
    <BatchDetail
      title={config.title}
      apiGet={__getPlanPurchase}
      client={CLIENTS.pwg}
      requestExtraParams={{ operation }}
      columnsFactory={(ctx) => planPurchaseColumns({ ...ctx, iccidHeaderName: "MDN" })}
      copyKeys={COPY_KEYS}
      exportAction={operation}
      retryOperation={operation}
      getRowPath={(row) => `${config.route}/${row.id}`}
    />
  );
};

export default PlanPurchaseBatch;
